import { batchActions } from 'redux-batched-actions'

import { fetchWithSpinner, fetchWrapper as fetch } from '../utils/fetch'
import { processMediaImages, processMediaPage, processMediaPosts, processMediaVideos } from '../utils/responseProcessing'

import urls from '../apiUrls'

export const SET_ERROR_FETCHING_MEDIA = 'SET_ERROR_FETCHING_MEDIA'
export const START_FETCHING_MEDIA = 'START_FETCHING_MEDIA'
export const STOP_FETCHING_MEDIA = 'STOP_FETCHING_MEDIA'
export const UPDATE_MEDIA = 'UPDATE_MEDIA'
export const UPDATE_MEDIA_PAGE = 'UPDATE_MEDIA_PAGE'
export const UPDATE_MEDIA_NULL = 'UPDATE_MEDIA_NULL'

export const startFetchingMedia = () => ({
    type: START_FETCHING_MEDIA,
})

export const stopFetchingMedia = () => ({
    type: STOP_FETCHING_MEDIA,
})

export const updateMedia = (rawResponseData) => ({
    type: UPDATE_MEDIA,
    payload: {
        /*data: {
            content: rawResponseData.content,
            title: rawResponseData.title,
        },*/
        videos: processMediaVideos(rawResponseData.content),
        images: processMediaImages(rawResponseData.content),
        posts: processMediaPosts(rawResponseData.content),
        title: rawResponseData.title,

        slug: rawResponseData.slug,
    },
})

export const updateMediaNull = (rawResponseData) => ({
    type: UPDATE_MEDIA_NULL,
    payload: {
        title: rawResponseData.title,
        errorNotFound: true,

        slug: rawResponseData.slug,
    },
})

export const updateMediaPage = (rawResponseData) => ({
    type: UPDATE_MEDIA_PAGE,
    payload: {
        data: processMediaPage(rawResponseData.content),
        title: rawResponseData.title,

        slug: rawResponseData.slug,
    },
})

export const setErrorFetchingMedia = (errorData) => ({
    type: SET_ERROR_FETCHING_MEDIA,
    payload: {
        errorData,
    },
})

export const fetchMedia = (slugg) => {
    return (dispatch) => {
        const url = 'https://tankimods.net'+urls.contentPages.replace(/:slug/g, slugg);

        let body = {
            slug: slugg,
        }

        dispatch(startFetchingMedia())

        const fetchPromise = fetch(url, {method: 'POST', body}).promise
            .then((rawResponseData) => {
                if (rawResponseData.content != null) {
                    dispatch(batchActions([
                        updateMedia(rawResponseData),
                        stopFetchingMedia(),
                    ], UPDATE_MEDIA))
                } else {
                    dispatch(batchActions([
                        updateMediaNull(rawResponseData),
                        stopFetchingMedia(),
                    ], UPDATE_MEDIA_NULL))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorFetchingMedia(errorData),
                    stopFetchingMedia(),
                ], SET_ERROR_FETCHING_MEDIA))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const fetchMediaPage = (slugg) => {
    return (dispatch) => {
        const url = 'https://tankimods.net'+urls.contentPages.replace(/:slug/g, 'media');

        let body = {
            slug: slugg,
        }

        dispatch(startFetchingMedia())

        const fetchPromise = fetch(url, {method: 'PATCH', body}).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorFetchingMedia(rawResponseData.context.msg),
                        stopFetchingMedia(),
                    ], SET_ERROR_FETCHING_MEDIA))
                } else {
                    dispatch(batchActions([
                        updateMediaPage(rawResponseData),
                        stopFetchingMedia(),
                    ], UPDATE_MEDIA_PAGE))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorFetchingMedia(errorData),
                    stopFetchingMedia(),
                ], SET_ERROR_FETCHING_MEDIA))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}